import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { CheckFilledIcon, RejectedFilledIcon } from 'transfix-icons'
import { brandColors, Tooltip } from 'transfix-ui'

export interface ITrackingTooltipProps {
  isValid: boolean
  shipmentId: number | string
  validatedELD: string[]
}

export const TrackingTooltip: FC<ITrackingTooltipProps> = ({
  isValid,
  shipmentId,
  validatedELD,
}) => {
  let eldValidMessage = ''

  if (validatedELD.length > 1) {
    const commaSeparatedELD = validatedELD.slice(0, validatedELD.length - 1)
    eldValidMessage = [commaSeparatedELD.join(', '), validatedELD[validatedELD.length - 1]].join(
      ' and '
    )
  } else {
    eldValidMessage = validatedELD[0]
  }

  return (
    <Tooltip
      position='top'
      id={`truckValid-${shipmentId}`}
      trigger={
        <Box ml={0.625} color={isValid ? brandColors.info : brandColors.error}>
          {isValid ? <CheckFilledIcon /> : <RejectedFilledIcon />}
        </Box>
      }>
      {isValid ? `Valid ${eldValidMessage} truck number` : `Invalid ELD truck number`}
    </Tooltip>
  )
}
